import type { Firm } from "../firms";

export const PERMISSION_SCOPES = {
  TAX_SUPERVISOR: "TAX_SUPERVISOR",
  ADMIN: "ADMIN",
  CLERK: "CLERK",
  ACCOUNTING: "ACCOUNTING",
  READONLY: "READONLY",
  DIY: "DIY",
  INVALID: "INVALID",
} as const;

export type PermissionScope =
  (typeof PERMISSION_SCOPES)[keyof typeof PERMISSION_SCOPES];

export interface Operator {
  id: string; // identity id (JWT `sub`)
  /**
   * The accounts operator id (`operators.id`) — distinct from `id`/`sub` (the
   * identity id). Used when the acting operator assigns THEMSELVES as a
   * customer's manager (take over). Always present: the accounts access token
   * carries it as a required claim.
   */
  operatorId: string;
  name: string;
  email: string;
  permissionScope: PermissionScope;
  firm: Firm;
  exp: number; // Expiration timestamp
}

export interface AuthContextType {
  operator: Operator | null;
  loading: boolean;
  loginWithGoogle: () => void;
  loginWithMicrosoft: () => void;
  error: string | null;
  logout: () => void;
}

export const TAX_ADVISORY_PERMISSION_SCOPES = [
  PERMISSION_SCOPES.TAX_SUPERVISOR,
  PERMISSION_SCOPES.ADMIN,
  PERMISSION_SCOPES.CLERK,
  PERMISSION_SCOPES.ACCOUNTING,
  PERMISSION_SCOPES.READONLY,
];
